import React from "react";
import MaestroLoader from "@components/MaestroLoader";
import { Box, Button, CardCover, Grid, Typography } from "@mui/joy";
import TableWidget from "./layouts/TableWidget";
import { primaryProperty, useGetAllBusinesses } from "@api/businessService";
import ListWidget from "./layouts/ListWidget";

const columns = [
    {
        id: 'name',
        numeric: false,
        disablePadding: true,
        sortable: true,
        label: 'Name',
        cell: (row, {LinkComponent}) => {
            return (<>
                <LinkComponent to={`/businesses/${row.id}`} relative={true} object={row}>
                    <Typography sx={{display: 'inline-block'}} fontWeight={'bold'}>{row.name}</Typography>
                </LinkComponent>

                {row.dba_name && (<Typography fontSize="sm"><Typography fontWeight={'bold'}>DBA</Typography> {row.dba_name}</Typography>)}

                {row.owner && (<Typography fontSize="sm"><Typography fontWeight={'bold'}>Primary Contact</Typography> <LinkComponent to={`/contacts/${row.owner.id}`} relative={true} object={row.owner}>{row.owner.name}</LinkComponent></Typography>)}
            </>)
        }
    },
    {
        id: 'address',
        numeric: false,
        disablePadding: false,
        sortable: false,
        label: 'Address',
        cell: (row, {LinkComponent}) => {
            if(!row.business_locations.length) {
                return null;
            }

            const primary = primaryProperty(row.business_locations);

            return (
                <LinkComponent to={`/properties/${primary.id}`} relative={true} object={primary}>
                    <Typography sx={{display: 'inline-block'}} fontWeight={'bold'}>{primary.address}</Typography>
                </LinkComponent>
            );
        }
    },
];

export default function BusinessListWidget(props) {
    return (
        <ListWidget
            query={useGetAllBusinesses}
            columns={columns}
            {...props}
        />
    );
}
